/**
 * Page 403 — accès refusé (P2 garde de route, 2026-07-07).
 *
 * Rendue par SectionGuard quand l'utilisateur connecté n'a pas la section de
 * navigation correspondant à la route (mêmes règles que le filtrage du rail :
 * hasSection / ROLE_SECTIONS). État honnête : pas de contenu, pas d'appel
 * réseau — le backend renverrait de toute façon 401/403.
 */
import { Link } from "wouter";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ShieldAlert, ArrowLeft, Home } from "lucide-react";
import { useTranslation } from "@/lib/i18n/i18n";

export default function Forbidden() {
  const t = useTranslation();
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gray-50 px-4">
      <Card className="w-full max-w-md" data-testid="forbidden-page">
        <CardContent className="pt-8 pb-6">
          <div className="flex flex-col items-center text-center">
            <div className="w-16 h-16 rounded-full bg-amber-50 flex items-center justify-center mb-4">
              <ShieldAlert className="h-8 w-8 text-amber-500" aria-hidden="true" />
            </div>
            <h1 className="text-3xl font-bold text-gray-900 mb-2">{t("notfound.forbiddenCode")}</h1>
            <h2 className="text-xl font-semibold text-gray-700 mb-3">
              {t("notfound.forbiddenTitle")}
            </h2>
            <p className="text-sm text-gray-500 mb-6 max-w-sm">
              {t("notfound.forbiddenMessage")}
            </p>
            <div className="flex flex-col sm:flex-row gap-2 w-full">
              <Button
                variant="outline"
                onClick={() => window.history.back()}
                className="flex-1"
              >
                <ArrowLeft className="w-4 h-4 mr-2" aria-hidden="true" />
                {t("notfound.back")}
              </Button>
              <Link href="/dashboard" className="flex-1">
                <Button className="w-full bg-brand-primary hover:bg-brand-primary/90">
                  <Home className="w-4 h-4 mr-2" />
                  {t("notfound.dashboard")}
                </Button>
              </Link>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
